/**
 * Multiline Ellipsis Directive
 *
 * <element multiline-ellipsis="MyText" />
 *
 * The only but obvious css requirement is that
 * the element this is placed on should have a set height or max height
 * with overflow-y: or overflow: hidden
 */

import * as angular from 'angular';
import { isNaN } from 'lodash-es';

export default function multilineEllipsis() {
  'ngInject';

  return {
    scope: {
      longText: '=multilineEllipsis'
    },
    restrict: 'A',
    template:
      '<span ng-transclude="link"></span><span class="_textContainer_" title="{{longText}}">{{longText}}</span>',
    link: _multilineEllipsisLink,
    transclude: {
      link: '?contentLink'
    }
  };
}

// Note: link() is not like controller function, it does not get injected variables.
// The full list includes controller and transcludeFn but we're not using either of those.
function _multilineEllipsisLink(scope, elem) {
  var $textContainer = angular.element('._textContainer_', elem);
  var maxHeight =
    parseInt(elem.css('max-height'), 10) || parseInt(elem.css('height'), 10);
  var offset = 3;

  if (!isNaN(maxHeight)) {
    // add a slight offset in case fonts are inconsistent across platforms e.g.(Helvetica not native in Windows)
    maxHeight += offset;
  } else {
    maxHeight = 0;
    throw new Error('multilineEllipsis requires CSS: height or max-height');
  }

  scope.$watch('longText', (newLongText) => {
    if (newLongText) {
      // update $textContainer element with newLongText to capture
      // new element size since the template isn't updated yet
      $textContainer.html(newLongText);

      // This seems a bit scary but it's actually pretty fast and text requiring ellipsis
      // is highly unlikely to change so this code only gets hit once
      while ($textContainer.outerHeight() > maxHeight) {
        // continuously replace words with ellipsis
        // until the remaining text fits in its container
        $textContainer.html((index, text) => {
          return text.replace(/\W*\s(\S)*$/, '...');
        });
      }
    }
  });
}
